import React, { FC } from 'react';
import API from 'core/Api';
import { buildClientEntity } from 'utils/helpers/client';
import { useActiveClientContext } from 'store/active-client';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import Loader from 'components/Loader';
import { createErrorFromResponse } from 'core/Error';
import { IEmployee } from './types';

export interface IProps {
  id: string;
}

const MassDocEmployees: FC<IProps> = ({ id }: IProps) => {
  const { t } = useTranslation();
  const { client } = useActiveClientContext();

  const { isLoading, error, data } = useQuery<IEmployee, Error>(
    [buildClientEntity('document-multi-users', client), { id }],
    (): Promise<IEmployee> => API.get(`document-holders/${id}/users`).then(res => res.data)
  );

  if (isLoading)
    return (
      <div className="m-5">
        <Loader />
      </div>
    );

  if (error) return <p>{createErrorFromResponse(error).message}</p>;

  return (
    <div>
      {data!.items.map((item: IEmployee) => {
        const groups = item.groups.map(gr => gr.name);
        return (
          <div>
            <span className="font-weight-bold">{`${item.first_name} ${item.last_name}`}</span>
            {` - ${groups.join(', ')}`}
          </div>
        );
      })}
    </div>
  );
};

export default MassDocEmployees;
